module.exports = __webpack_public_path__ + "static/media/Phone-icon.cc84e800.svg";